import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import LogoBrand from '../img/logo.png';

function GeneralNavbar() {
    return (
        <Navbar expand="lg" className="bg-body-tertiary" variant='dark'>
            <Container>
                <Navbar.Brand href="/">
                    <img
                        src={LogoBrand}
                        width="120"
                        className="d-inline-block align-top"
                        alt="DeathDash Logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/">Home</Nav.Link>
                        <Nav.Link href="/support">Support</Nav.Link>
                        <Nav.Link href="/contact">Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default GeneralNavbar;
